<template>
  <div class="pwc-survey-info">
    <!-- <van-nav-bar title="问卷调查" fixed /> -->
    <pwc-container class="survey-container">
      <van-image class="logo" :src="require('../../../assets/logo.png')" />
      <div v-if="!submited" class="survey-label-container">
        <h6 class="survey-title">{{ data.Title }}</h6>
      </div>
      <DyForm v-if="!submited" ref="dyform" :data="data" :form-data="formData" :file-keys="fileKeys" @submitForm="(val) => {submitForm(val)}" />
      <!-- <div v-if="!submited" class="pwc-form-privacy">
        <span>
          <a href="https://youplusapplication.businesstrainingshpwc.com/application/TermsOfUse.html">&nbsp;使用条款&nbsp;</a>和
          <a href="https://youplusapplication.businesstrainingshpwc.com/application/PrivacyStatement.html">&nbsp;隐私条款</a></span>
      </div> -->
      <pwc-thanks-info v-if="submited" />
    </pwc-container>
  </div>
</template>

<script>
import PwcContainer from '@/views/layout/mobile/PwcContainer'
import { mapState } from 'vuex'
import DyForm from '@/components/PwcDyForm/mobile'
import { http } from '@/api'
import {
  Image,
  NavBar,
  Notify
} from 'vant'
import { PublicEvent } from '@/api/collection'
import PwcThanksInfo from '../common/thanks'
import { common } from '../common/mixin.js'

export default {
  name: 'CounsellingMobile',
  components: {
    PwcContainer,
    DyForm,
    [NavBar.name]: NavBar,
    [Image.name]: Image,
    PwcThanksInfo
  },
  mixins: [common],
  data() {
    return {
      submited: false,
      submitData: {}
    }
  },
  computed: {
    ...mapState(['loading', 'userInfo'])
  },
  methods: {
    async submitForm(val) {
      console.log('formData :', val)
      this.data.Questions.forEach(item => {
        if (item.type === 'fileupload') {
          this.submitData['resumeURL'] = val[item.key]
        }
        if (item.type === 'textarea') {
          this.submitData['category'] = val[item.key]
        }
      })
      this.submitData['leadId'] = this.userInfo.leadId
      const res = await http(
        {
          path: PublicEvent.ApplyForCounselling.path,
          method: PublicEvent.ApplyForCounselling.method,
          data: this.submitData
        }
      )
      if (res.resultCode === '0') {
        Notify({ message: '提交成功', duration: 3 * 1000 })
        this.submited = true
      }
    }
  }
}
</script>

<style lang="scss">
.pwc-form-privacy {
  text-align: center;
  font-size: 16px;
  padding-top: 30px;
  padding-bottom: 15px;
  background-color: #fff;
  max-width: 640px;
  margin: auto;
  height: auto;
  width: auto;
  overflow: hidden;
}
.pwc-survey-info {
   font-family: 'Microsoft YaHei', Georgia, "Times New Roman", Times, serif;
  .survey-container {
    position: relative;
    background-color: #fff;
    padding: 20px;

    .logo {
      width: 100%;
      margin: 0px auto;
      padding: 20px 30px 30px 30px;
    }

    .survey-label-container {
      margin-top: 20px;
      .survey-title {
        font-size: 18px;
        font-weight: normal;
        text-align: center;
      }
      .survey-desc {
        font-size: 14px;
        font-weight: normal;
        text-align: left;
        line-height: 22px;
        display: inline-block;
        margin-bottom: 20px;
      }
    }
  }
}

.pwc-dialog-submit {
  padding: 22px;
  padding-top: 36px;
  padding-bottom: 6px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}
@-webkit-keyframes fadeIn {
  0% {
    opacity: 0; /*初始状态 透明度为0*/
  }
  50% {
    opacity: 0; /*中间状态 透明度为0*/
  }
  100% {
    opacity: 1; /*结尾状态 透明度为1*/
  }
}
</style>
